import React, { useState } from "react";
import { Link } from "react-router-dom";

import { TiUserAdd } from "react-icons/ti";
import Swal from "sweetalert2";
import { apiPath, RoutePath } from "../../utility/Constant";
import { deleteData } from "../../hooks/delete";

const TeamCard = ({ member, user }) => {
  const [hidden, setHidden] = useState(false);
  const { addMember } = RoutePath;
  const { teamListApi } = apiPath;
  const handleDelete = (event) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteData(`${teamListApi}/${event.target.id}`);
        setTimeout(() => {
          setHidden(true);
        }, 1000);
      }
    });
  };
  return (
    <div className={hidden && "hidden"}>
      {member ? (
        <div className="card bg-base-100 shadow-xl">
          <figure>
            <img
              src={
                member.image
                  ? member.image
                  : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTsG7BvPQGa8tgLWZX4sC-MvSltacqxl5-5t6COkDpz8cJHGg6K75Yz0VsjvpDlI8VGboE&usqp=CAU"
              }
              alt={member.name + " " + "Image"}
              className="h-[275px] object-cover w-full"
            />
          </figure>

          <div className="p-3">
            <h2 className="text-2xl text-center uppercase font-semibold">
              {member.name}
            </h2>
            <p className="text-center text-lg">{member.designation}</p>
            <div className="card-actions justify-between">
              <Link
                to={`/teamList/${member._id}`}
                className="btn btn-outline btn-xs border-blue-500 text-blue-500 hover:bg-blue-500 hover:border-blue-500 hover:text-white"
              >
                Edit
              </Link>
              {user === "admin" && (
                <button
                  id={member._id}
                  onClick={handleDelete}
                  className="btn btn-outline btn-xs border-red-500 text-red-500 hover:bg-red-500 hover:border-red-500 hover:text-white"
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>
      ) : (
        <Link
          to={addMember}
          className="flex justify-center items-center rounded-xl bg-gray-50 shadow-xl h-full "
        >
          <p className="text-8xl">
            <TiUserAdd />
          </p>
        </Link>
      )}
    </div>
  );
};

export default TeamCard;
